import { render, staticRenderFns } from "./SPrevValuesDictionaryEditor.vue?vue&type=template&id=38299f04&scoped=true"
import script from "./SPrevValuesDictionaryEditor.vue?vue&type=script&lang=js"
export * from "./SPrevValuesDictionaryEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38299f04",
  null
  
)

export default component.exports